const analyticsEvents = {
  loginPage: 'Login page',
  createAccountLinkClick: 'Login page create account link click', // added by request from Katrin Gribova
  registerPage: 'Register page', // SCNT-3081
  registerChange: 'Register change', // SCNT-3655
  registerFailed: 'Signup failed', // SCNT-5216

  howItWorks: 'How it works', // SCNT-2276, TODO remove it?
  changeFrequencyClick: 'Change frequency click', // SCNT-1456
  changeFrequency: 'Change frequency', // SCNT-1456
  unsubscribeClick: 'Unsubscribe click', // SCNT-1456
  skipMonthClick: 'Skip month click', // SCNT-1456
  unsubscribe: 'Unsubscribe choose option', // SCNT-3460
  upgradePopup: 'Upgrade popup', // SCNT-1456
  pageVisit: {
    upgrade: 'Upgrade page', // SCNT-3508
    downgrade: 'Downgrade page', // SCNT-3553
    cardUpdate: 'Card-update page visit', // SCNT-1913
    cardUpdate50: 'Card-update-50 page visit', // SCNT-1913
    caseCardUpdate: 'Case card update page', // SCNT-1947
    productPage: 'Product page', // SCNT-4194
    productPageLanding: 'Product page landing', // SSR-54
    queuePage: 'Queue page', // SCNT-4431
    popupShop: 'Sb nym popup shop', // SCNT-4517
    planPage: 'Plan page', // SCNT-5000
    incubatorPage: 'Incubator page', // SCNT-5200
    skincareIntroPage: 'Skincare intro page', // SCNT-5543
    flashSale: 'Flash sale page', // SCNT-6360
    caseMonthlyPage: 'Case monthly page', // by request from @sergei
    thankYou: 'Thank you page', // SB-206
  },
  prepaidCardUpgradePopup: 'Prepaid card upgrade popup', // SCNT-2390
  stopUnsubscribePopup: 'Stop unsubscribe popup', // SCNT-2372
  stopUnsubscribe: 'Stop unsubscribe', // SCNT-2372
  twoThreeScents: '2-3 scents upgraded popup', // SCNT-2416 TODO remove it?
  twoThreeScentsUpgraded: '2-3 scents upgraded popup click', // SCNT-2416 TODO remove it?
  giftsetBannerClick: 'Giftset banner click', // SCNT-2523
  resubscribe: 'Resubscribe', // SCNT-2563
  resubscribeButton: 'Resubscribe button',
  resubscribePopup: {
    getBackTogether: 'Popup1', // SCNT-2563
    resubscribeWithDiscount: 'Popup2', // SCNT-2563
    postCancel: 'Resubscribe post cancel popup', // SCNT-2947
  },
  couponsPage: 'Coupon page', // SCNT-3922
  giftsetPage: 'Giftset main', // SCNT-2611
  giftsetAddToCart: 'Giftset add to cart', // SCNT-2611
  submitReview: 'Submit review', // SCNT-2627
  incubatorSubmitReview: 'Incubator submit review', // SCNT-6023
  reviewPopup: 'Review popup', // SCNT-2627
  writeReview: 'Write a review', // SCNT-2807
  quiz: {
    recommender: 'Recommender', // SCNT-2798
    step1: 'Quiz', // SCNT-2795
    step2: 'Quiz step 2', // SCNT-2795
    step3: 'Quiz step 3', // SCNT-2795
    step4: 'Quiz step 4', // SCNT-6071
    step5: 'Quiz step 5', // SCNT-6071
  },
  acQuiz: { // SB-8
    step1: 'Ac quiz step 1',
    step2: 'Ac quiz step 2',
    step3: 'Ac quiz step 3',
    step4: 'Ac quiz step 4',
    bannerClick: 'Ac quiz banner click',
    introPageSelectOption: 'Ac quiz intro page select option',
    fullListClick: 'Ac quiz full product list button click',
    introPage: 'Ac quiz intro page',
    registrationPage: 'Ac quiz registration',
    pickPage: 'Ac quiz pick page',
  },
  copyLink: 'Copy link', // SCNT-2882
  share: 'Share', // SCNT-2882
  shareLinkClick: 'Share link click', // SCNT-3033
  invitePage: 'Invite page', // SCNT-2882
  queuePopup: 'Queue popup', // SCNT-2953
  queuePopupClick: 'Queue popup click', // SCNT-5276
  visitPopup: 'Visit popup', // SCNT-5276
  visitPopupClick: 'Visit popup click', // SCNT-5276
  visitBanner: 'Visit banner ', // SCNT-5276
  visitBannerClick: 'Visit banner click', // SCNT-5276
  thankYouPointerClick: 'Thank you arrow click', // SCNT-4356
  thankYouAddToQueue: 'Thank you add to queue', // SCNT-3095
  popupCandles: 'Popup candles', // SCNT-3071
  popupLipBalms: 'Popup lip balm', // SCNT-3303
  popupMakeup: 'Popup makeup', // SCNT-3952
  popupSkincare: 'Skincare popup', // SCNT-5297
  popupSkincareClick: 'Skincare popup click', // SCNT-5297
  popupWellness: 'Wellness popup', // SCNT-6216
  popupWellnessClick: 'Wellness popup click', // SCNT-6216
  twoProductsFor25: '2 for 25', // SCNT-3127
  paymentPage: 'Payment page', // SCNT-3234
  paymentPageForm: 'Payment page form', // vero
  paymentForm: {
    couponCode: 'Payment form coupon code', // SCNT-4008
    method: 'Payment form method', // SCNT-4008
    firstName: 'Payment form first name', // SCNT-4008
    lastName: 'Payment form last name', // SCNT-4008
    autocomplete: 'Payment form autocomplete', // SCNT-4008
    street: 'Payment form street address', // SCNT-4008
    apt: 'Payment form apt', // SCNT-4008
    zipCode: 'Payment form zip', // SCNT-4008
    billingZipCode: 'Payment form billing zip', // SCNT-6192
    city: 'Payment form city', // SCNT-4008
    state: 'Payment form state', // SCNT-4008
    telephone: 'Payment form phone number', // SCNT-4008
    facebookMessenger: 'Payment form messenger', // SCNT-4008
    billingAddress: 'Payment form billing address', // SCNT-4008
    cardNumber: 'Payment form card number', // SCNT-4008
    holderName: 'Payment form card name', // SCNT-4008
    expDate: 'Payment form card date', // SCNT-4008
    cvc: 'Payment form card cvv', // SCNT-4008
    placeOrder: 'Place order', // SCNT-3234
  },
  quickViewButton: 'Quick view button',
  addTo: {
    queue: 'Add to queue', // SCNT-3221
    cart: 'Add to cart', // SCNT-3221
  },
  recommendationPopup: {
    queue: 'Recommendation popup queue', // SCNT-3173
    cart: 'Recommendation popup cart', // SCNT-3173
  },
  addressValidationPopup: {
    open: 'Address validation popup', // SCNT-3192
    close: 'Close address verification', // SCNT-3192
    click: 'Address validation click', // SCNT-3192
  },
  selectPlan: [
    'Select 1 product', // SCNT-3308
    'Select 2 products', // SCNT-3308
    'Select 3 products', // SCNT-3308
  ],
  referrerLandingPageURL: 'Referrer landing page URL', // SCNT-3347
  mainPagePlayVideo: 'Main page play video', // SCNT-3407
  trackingNumberClick: 'Tracking number click', // SCNT-3497
  cardFailed: {
    309: 'AB card filed 309 discount popup', // SCNT-3148
    110: 'AB card filed 110 discount popup', // SCNT-3148
  },
  mainPageSlider: 'Main page slider', // SCNT-3549
  inviteBanner: 'AB invite banner test', // SCNT-3555
  downgrade: 'Downgrade', // SCNT-3553
  welcomePage: 'Welcome page', // SCNT-3574
  pickPage: {
    main: 'Pick page', // SCNT-3574
    filterClick: 'Pick page filter', // SCNT-3885
    filterSelect: 'Pick page filter select', // SCNT-3683
    description: 'Pick page description', // SCNT-3683
    queue: 'Pick page submit to the queue', // SCNT-3683
    cart: 'Pick page cart', // SCNT-4819
    genderFilter: 'Pick page gender filter', // SCNT-5502
    perfumeFilter: 'Pick page perfume filter', // SCNT-5502
    showDetails: 'Pick page show details', // SCNT-5543
    skincareFilters: 'Pick page skincare filters', // SCNT-5543
    // skincareDetails: 'Pick page skincare details', // SCNT-5543
  },
  blog: 'Blog', // SCNT-3599
  searchSuggestionClicked: 'Search suggestion clicked', // SCNT-4068
  profileOrderStatus: 'Profile order status', // SCNT-4040
  profileProductsInQueue: 'Profile products in queue', // SCNT-4040
  profileReviewsWritten: 'Profile reviews written', // SCNT-4040
  profileRatedProducts: 'Profile rated products', // SCNT-4040
  profileOrderStatusProduct: 'Profile order status product', // SCNT-4040
  trackingPage: { // SCNT-4026
    main: 'Tracking number page', // SCNT-4026
    blocks: 'Tracking page reco blocks', // SCNT-4026
    addAll: 'Tracking page add all', // SCNT-4026
    getRecommendations: 'Tracking page get recommendations', // SCNT-4026
    collections: 'Tracking page reco blocks', // SCNT-4288
    swipeProductsCarousel: 'Tracking page swipe products carousel',
  },
  fragranceFinderPage: 'Fragrance finder page', // SCNT-4004
  popularInStatesPage: 'Popular in states page', // SCNT-3853
  collectionContinue: 'Collection continue', // SCNT-3910
  collectionAddToQueueButton: 'Collection add to queue button', // achumakov 10.06.19
  mainWomenBannerClick: 'Main-women banner click', // SCNT-4427
  mainMenBannerClick: 'Main-men banner click', // SCNT-4427
  mainPageQuickLinkClick: 'Main page quick link click', // no issue, @olya asked
  notificationClick: 'Notification click', // no issue, @Sergey Bugorkov asked
  notificationCloseClick: 'Notification close click', // no issue, @Sergey Bugorkov asked
  faqLinkClick: 'Faq link click', // SCNT-4849
  noteClick: 'Note click', // SCNT-4904

  mainPageQuiz: {
    quiz1: 'Main page quiz', // SCNT-4424
    quiz2: 'Main page quiz 2', // SCNT-4424
    quiz3: 'Main page quiz 3', // SCNT-4424
    continue: 'Main page quiz continue', // SCNT-4424
  },

  premiumProducts: {
    optOutPremiumPopup: 'Opt out premium popup', // SCNT-4526
  },

  makeupLanding: {
    main: 'Makeup landing page', // SCNT-4476
    pick: 'Main makeup landing pick', // SCNT-4476
  },

  mainPageLoginClick: 'Main page login click', // SCNT-5312

  newSubscribe: { // SCNT-5105, SCNT-6038
    planStep: 'Plan page',
    previewStep: 'Preview page',
    shippingStep: 'Shipping page',
    submitShipping: 'Submit shipping',
    reviewStep: 'Payment page',
    placeOrder: 'Place order',
    summaryPage: 'Summary page', // SB-23
  },

  cancelFlow: { // SCNT-5453
    accessToAbTest: 'Unsubscribe flow test',
    flowStart: 'Unsubscribe flow start',
    selectReason: 'Select unsubscribe reason',
    changedMind: 'Changed mind',
    resubscribeNps: 'Resubscribe nps',
    feedback: { // SCNT-6188
      activate: 'Feedback form activated',
      send: 'Feedback form send',
    },
    billingAndShipping: { // SCNT-6228
      start: 'Unsubscribe issues check',
      updateAddress: 'Update address',
      updateBilling: 'Update billing information',
      addressUpdated: 'Address update success',
    },
    pageVisit: 'Unsubscribe flow page', // SCNT-6340
  },

  cancelOffer25off: { // SCNT-6121
    start: 'Unsubscribe offer start',
    popup: 'Unsubscribe offer popup',
    accept: 'Unsubscribe offer accept',
  },

  showMoreRecommendations: 'Recommender show more', // SCNT-5260

  subscribeButtonClick: 'Subscribe button click', // SCNT-5342

  applePayButton: 'ApplePay button', // SCNT-6009

  membershipButtonClick: 'Membership button click', // SCNT-6075

  tossIn: {
    visit: 'Toss in page',
    continue: 'Toss in continue',
    purchase: 'Toss in continue popup click',
  },

  buyQueue: { // SCNT-6028
    visit: 'Buy queue page',
    add: 'Buy queue add to cart',
    continue: 'Buy queue continue',
    purchase: 'Buy queue continue popup click',
    click: 'Buy queue click', // SB-160
  },

  concept: { // SCNT-6161
    click: 'Concept click',
    view: 'Concept view',
    viewAction: 'Concept view action',
    vote: 'Concept vote',
    banner: 'Concept banner click',
  },

  surveyForm: { // SCNT-6253
    page: 'Customer survey form page',
    banner: 'Customer survey form banner',
  },

  changeGender: 'Change gender', // SCNT-5577

  casesSubscription: { // SB-9
    main: 'Case sub page',
    choose: 'Case sub page choose',
    remove: 'Case sub page remove',
    decline: 'Case sub page decline',
  },

  mix: { // SCNT-6345
    mainPage: 'Main mix page', // SCNT-6364
    productClick: 'Mix product click', // SCNT-6364
    burgerMenuLinkClick: 'Mix burger menu link click', // SCNT-6364
    welcomePage: 'Mix welcome page', // SCNT-6365
    subHeaderLinkClick: 'Mix sub header link click', // SCNT-6365
  },

  flashSale: { // SCNT-6360
    popup: 'Flash sale popup',
    popupClick: 'Flash sale popup click',
  },

  mainPageStory: {
    click: 'Story click',
    view: 'Story view',
    action: 'Story action',
  },

  tech: {
    beginStart: 'Tech begin start',
    beginSuccess: 'Tech begin success',
    beginError: 'Tech begin error',
    commitStart: 'Tech commit start',
    commitSuccess: 'Tech commit success',
    commitError: 'Tech commit error',
    callVindiciaStart: 'Tech callVindicia start',
    callVindiciaSuccess: 'Tech callVindicia success',
    callVindiciaError: 'Tech callVindicia error',
    beginPaypal: 'Tech beginPaypal',
    commitPaypal: 'Tech commitPaypal',
    beginApplePay: 'Tech beginApplePay',
    commitApplePay: 'Tech commitApplePay',
    syncUserAndSubscription: 'Tech syncUserAndSubscription',
    buyGiftCard: 'Tech buyGiftCard',
    buyGiftSubscription: 'Tech buyGiftSubscription',
    buyOrder: 'Tech buyOrder',
    buySubscription: 'Tech buySubscription',
    postponedSubscriptionProcessing: 'Tech postponedSubscriptionProcessing',
    recursionSubscriptionProcessing: {
      done: 'Tech recursionSubscriptionProcessing done',
    },
    redeemCoupon: 'Tech redeemCoupon',
    redeemCouponNoCharge: 'Tech redeemCouponNoCharge',
    redeemGiftSubscription: 'Tech redeemGiftSubscription',
  },

  improveRecommendations: {   // SCNT-6413
    start: 'Recommendations improve start',
    finish: 'Recommendations improve finish',
    like: 'Recommendations improve like',
    dislike: 'Recommendations improve dislike',
  },

  newThankYouPage: {
    goToCatalogClick: 'Thank you go to catalog click',
    upgradeOptionClick: 'Thank you upgrade option click',
    upgradeContinueClick: 'Thank you upgrade continue click',
  },

  upgradeProductPage: {   // SB-79
    visit: 'Upgrade product page',
    upgradeOptionClick: 'Upgrade product option click',
    upgradeContinueClick: 'Upgrade product continue click',
    goToCatalogClick: 'Upgrade product go to catalog click',
  },

  upgradeSimplePage: {   // SB-155
    abStart: 'Ab upgrade page start',
    visit: 'Upgrade simple page',
    upgradeOptionClick: 'Upgrade simple option click',
    upgradeContinueClick: 'Upgrade simple continue click',
    goToCatalogClick: 'Upgrade simple go to catalog click',
  },

  upgradeSliderBanner: {  // SB-211
    upgradeOptionClick: 'Upgrade slider click',
    upgradeContinueClick: 'Upgrade slider continue click',
    goToCatalogClick: 'Upgrade slider go to catalog click',
  },

  caseSubscriptionPage: {   // SB-154
    visit: 'Case subscription page',
    click: 'Get case button click',
  },

  promote: { // SB-121
    buyQueue: 'Buy queue click',
    casesBanner: 'Cases banner click',
    subscriptionUpgrade: 'Subscription upgrade click',
  },

  personalReferral: 'personal referral', // SB-106

  profileMenuMobile: 'Profile menu mobile', // SB-253
}


export default analyticsEvents
